module.exports = __webpack_public_path__ + "static/media/total_uploads.0f552867.svg";